export default {
	successDeleteMessage: 'L’export a été supprimé avec succès',
	successCancelMessage: 'L’export a été annulé avec succès',
	generationFailedMessage: 'Une erreur est survenue lors de la génération de l’export.',
	nbRowText: 'Export | Exports',
	urls: {
		downloadExport: '/api/projects/{projectToken}/exports/{exportId}/file'
	}
};
